import { FavouriteProduct } from 'store/favourite/types';
import { SearchResultProduct } from 'store/search/types';

const getFavProductsFromSearchResults = (searchProducts: SearchResultProduct[]) => {
  const result: FavouriteProduct[] = [];
  searchProducts.forEach((sp) => {
    if (sp.favourited) {
      result.push({
        sku: sp.sku,
      } as FavouriteProduct);
    }
  });
  return result;
};

export default getFavProductsFromSearchResults;
